const enum CustomEventTypes {
  ChatMessageSent = 'Chat Message Sent',
  NutritionistSession = 'Nutritionist Session',
  PrimaryGoalChanged = 'Primary Goal Changed',
  PrimaryGoalMetricsChanged = 'Primary Goal Metrics Changed',
  GoalMetricTargetChanged = 'Goal Metric Target Changed',
  MemberNoteAdded = 'Member Note Added',
  MemberNotePinned = 'Member Note Pinned',
  StartPresentationMode = 'Start Presentation Mode',
  StartWebMembersPresentationMode = 'Start Web Members Presentation Mode',
  WebMembersPresentationModeAdminAuthenticated = 'Web Members Presentation Mode - Admin Authenticated',
  WebMembersPresentationModeMemberImpersonated = 'Web Members Presentation Mode - Member Impersonated',
  WebMembersPresentationModeMemberImpersonationFailed = 'Web Members Presentation Mode - Member Impersonation Failed',
  NutritionistHomeOpened = 'Nutritionist Home Opened',
  NutritionistHomeCalendarEventClicked = 'Nutritionist Home Calendar Event Clicked',
  NutritionistHomeSmsReminderSent = 'Nutritionist Home SMS Reminder Sent',
  HealthDataReportGenerated = 'Health Data Report - Generated',
  HealthDataReportPdfGenerated = 'Health Data Report - PDF Generated',
  HealthDataReportSentToUser = 'Health Data Report - Sent to User'
}

export default CustomEventTypes
